<template>
    <div class="form-builder-input" v-if="question">

        <input
            v-if="question.field_type === 'line' && !question.mask_field"
            :readonly="readOnly"
            class="form-control"
            type="text"
            v-model="value"
            :required="question.is_required"
        />

        <input
            v-if="question.field_type === 'line' && question.mask_field"
            :readonly="readOnly"
            class="form-control"
            type="text"
            v-model="value"
            v-mask="masks[question.mask_field]"
            :required="question.is_required"
        />

        <input
            v-if="question.field_type === 'cpf'"
            :readonly="readOnly"
            class="form-control"
            type="tel"
            v-model="value"
            v-mask="masks.CPF"
            :required="question.is_required"
        />

        <input
            v-if="question.field_type === 'cep'"
            :readonly="readOnly"
            class="form-control"
            type="tel"
            v-model="value"
            v-mask="masks.CEP"
            :required="question.is_required"
        />

        <input
            v-if="question.field_type === 'number'"
            :readonly="readOnly"
            class="form-control"
            type="number"
            min="0"
            v-model="value"
            :required="question.is_required"
        />

        <textarea
            v-if="question.field_type === 'text'"
            :readonly="readOnly"
            class="form-control"
            v-model="value"
            :required="question.is_required"
        ></textarea>

        <b-form-select
            v-if="question.field_type === 'choice' && questionTranslated !== undefined"
            :readonly="readOnly"
            v-model="value"
            :options="questionTranslated"
            :required="question.is_required"
        ></b-form-select>

        <b-form-checkbox-group
            v-if="question.field_type === 'multichoice' && questionTranslated !== undefined"
            :disabled="readOnly"
            v-model="value"
            :value-field="'value'"
            :name="'question-checkbox-' + question.id"
            :options="questionTranslated"
            stacked
            :required="question.is_required"
        ></b-form-checkbox-group>

        <datetime-picker
            v-if="question.field_type === 'date'"
            v-model="value"
            :readonly="readOnly"
            :initial-value="value"
            :hide-time="true"
            :allow-null="question.is_required"
            :required="question.is_required"
        ></datetime-picker>

        <datetime-picker
            v-if="question.field_type === 'datetime'"
            v-model="value"
            :readonly="readOnly"
            :initial-value="value"
            :hide-time="false"
            :allow-null="question.is_required"
            :required="question.is_required"
        ></datetime-picker>

      <div
          v-if="question.field_type === 'boolean'"
          :disabled="readOnly"
          class="d-inline-flex justify-content-between align-items-center"
      >
        <b-form-radio-group :checked="value" :name="'checkbox-' + question.id" :required="question.is_required">
          <b-form-radio :value="true">{{ $lang.get("common.Yes") }}</b-form-radio>
          <b-form-radio :value="false">{{ $lang.get("common.No") }}</b-form-radio>
        </b-form-radio-group>
      </div>

<!--      <b-form-checkbox
            v-if="question.field_type === 'boolean'"
            v-model="value"
            :disabled="readOnly"
            :unchecked-value="false"
            switch
            :required="question.is_required"
            :name="'checkbox-' + question.id"
        ></b-form-checkbox>-->

    </div>
</template>
<script>
    import Masks from '../services/Masks';

    export default {

        props: ['initialValue', 'question', 'readOnly', 'locale'],

        data: () => { return {
            value: null,
            masks: Masks,
            questionTranslated: [],
        }},

        mounted: function() {

          let valueFromProp = this.initialValue;

          if (this.question.field_type === 'boolean') {
            console.log(valueFromProp);
            //valueFromProp = false;
          }

          if (this.initialValue) {
            this.value = valueFromProp;
            return
          }

          this.translateChoiceFields();

          if(this.question.default_value !== null) {
            this.value = this.question.default_value;
          }

        },

        watch: {
            value: function (newValue) {

                this.$emit('input', newValue);
            }
        },

        methods: {
          translateChoiceFields () {

            if (this.locale === undefined) {
              return;
            }

            //Convert text to tranlatable field
            if (this.question.field_type === 'choice' || this.question.field_type === 'multichoice') {
              if (this.question.metadata.choices !== undefined && Object.keys(this.question.metadata.choices).length > 0) {
                this.question.metadata.choices.forEach(function (choice){
                  this.questionTranslated.push({
                    'text' : choice.text[this.locale],
                    'value' : choice.value,
                  });
                }.bind(this));
                this.$forceUpdate();
              }
            }
          }
        }

    }
</script>
